import {
  getAllChildrenStrings,
  getHeadingId,
} from '@ria-client/supergraph/structuredContent/table-of-contents';
import { isStructuredContent, type StructuredContentDocument } from '../types';

type ContentHeading = {
  id: string;
  header: string;
};

export const getChildrenHeadings = (parentDocument: StructuredContentDocument) => {
  const contentHeadings: ContentHeading[] = [];

  const findContentHeadings = (doc: StructuredContentDocument) => {
    if (['ContentHeading'].includes(doc.type) && doc.props.level === 2) {
      const childrenString = getAllChildrenStrings(doc);
      contentHeadings.push({
        id: getHeadingId(childrenString),
        header: childrenString,
      });
    }

    const children = doc.props.children;

    if (Array.isArray(children)) {
      children.forEach(child => {
        if (isStructuredContent(child)) findContentHeadings(child);
      });
    }

    return contentHeadings;
  };

  return findContentHeadings(parentDocument);
};

/** Returns undefined when the document contains no level-2 content heading. */
export const getChildHeadingId = (doc: StructuredContentDocument): string | undefined => {
  return getChildrenHeadings(doc)[0]?.id;
};
